import React, { useEffect, useState } from 'react'
import A4Page from '../A4Page'
import TopDetail from '../TopDetail'
import Page1 from './Page1'
import useOrderStore from 'store/client/orderStore'
import { ReactComponent as ZaraFscSimsek} from '../../../../../assets/globalsymbol/fscsimsekbestgray.svg'
import { ReactComponent as ZaraFscHarman } from '../../../../../assets/globalsymbol/harmanbestgray.svg'
import { ReactComponent as ZaraFscRpack } from '../../../../../assets/globalsymbol/rpackbestgray.svg'


const loadSVG = async (code) => {
  try {
    const trimmedCode = code?.trim()?.replace(/\s+/g, '') || '';
    const module = await import(`../../../../../assets/extrahomecard/${trimmedCode}.svg`);
    const component = module.default || module.ReactComponent || module;
    return component;
  } catch (error) {
    console.error(`[loadSVG] SVG yüklenemedi. Kod: ${code}, Hata:`, error);
    return null;
  }
};

const CardComponent = ({ referenceCode, data, selectedFscType,referance }) => {

  const [SvgComponent, setSvgComponent] = useState(null);
  const [FscComponent, setFscComponent] = useState(null);
  const [bottom, setBottom] = useState(18.6);
  const [right, setRight] = useState(19);
  const [Reverse, setReverse] = useState(false);

  useEffect(() => {
    switch (data.company.id) {  
      case "676976a49044968a2edbea39":
        setFscComponent(() => ZaraFscRpack);
        break;
      case "6562742a5b252fdddcc588e7":
        setFscComponent(() => ZaraFscHarman);
        break;
      default:
        setFscComponent(() => ZaraFscSimsek);
    }
  
    if (referenceCode) {
      loadSVG(referenceCode)
        .then((component) => {
          if (component) {
            setSvgComponent(() => component);
          }
        })
        .catch((error) => {
          console.error("[CardComponent] SVG yüklenirken hata:", error);
        });
    }
  }, [referenceCode, data.company.id]);

  if (!SvgComponent) {
    return <span>Loading...</span>;
  }

  // KEEPAWAY için sabit boyutlar: 22mm x 55mm
  const isKeepAway = referance?.code?.trim()?.replace(/\s+/g, '').toUpperCase() === 'KEEPAWAY';
  const svgWidth = isKeepAway ? '22mm' : (referance?.width ? `${referance.width}mm` : "100%");
  const svgHeight = isKeepAway ? '55mm' : (referance?.height ? `${referance.height}mm` : "auto");

  return (
    <div style={{ position: "relative", width: "100%", height: "100%" }}>
      {typeof SvgComponent === "function" ? (
        <SvgComponent width={svgWidth} height={svgHeight} />
      ) : typeof SvgComponent === "string" ? (
        <img 
          src={SvgComponent} 
          alt="SVG Image" 
          style={{ 
            width: svgWidth, 
            height: svgHeight,
            display: 'block',
            objectFit: 'contain'
          }} 
        />
      ) : (
        <div>SVG formatı desteklenmiyor: {typeof SvgComponent}</div>
      )}
      {referance.shape === "nosymbol" ? (
        <></>
      ) : (
        <div
  style={{
    position: "absolute",
    bottom: Reverse ? "auto" : bottom,
    right: Reverse ? "auto" : right,
    top: Reverse ? bottom : "auto",
    left: Reverse ? right : "auto",
    transform: Reverse ? "rotate(-180deg)" : "none",
  }}
>
  <FscComponent width="5.5mm" height="8.3mm" fill="red" />
</div>


        )}


    </div>
  );
};

const EkstraMain = ({ data, selectColor, tab }, ref) => {
  const [CardBackBack, setCardBackBack] = useState(null);
  const { referance } = useOrderStore();
  const [RefWidth, setRefWidth] = useState(0);
  const [RefHeight, setRefHeight] = useState(0);
  useEffect(() => {
    if (referance?.code) {
      loadSVG(referance.code)
        .then((component) => {
          setCardBackBack(() => component);
        })
        .catch((error) => {
          console.error("[useEffect - referance] SVG yüklenirken hata:", error);
        });
    }
  }, [referance]);

  const labelData = data?.extraHomeCardLabel;
  const currentLabel = labelData?.[selectColor];

  if (!currentLabel || !currentLabel.sizes) {
    return <div>Label verisi bulunamadı. Lütfen verileri kontrol edin.</div>;
  }

  const filteredAndGroupedSizes = currentLabel.sizes
    .filter((item) => item.amount > 0)
    .reduce((acc, item, index) => {
      const groupIndex = Math.floor(index / referance?.linecount);
      if (!acc[groupIndex]) {
        acc[groupIndex] = { items: [], startIndex: index - (index % referance?.linecount) };
      }
      acc[groupIndex].items.push(item);
      return acc;
    }, []);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }} ref={ref}>
      {referance?.line1 ? (
        filteredAndGroupedSizes.map((groupObj, groupIndex) => (
          <A4Page key={groupIndex} type="dikey">
            <div className="space-y-5" style={{ position: 'relative' }}>
              <TopDetail values={data} selectColor={selectColor} tab={tab} />
              {groupObj.items.map((sizeData, index) => (
                <div 
  style={{ 
    zIndex: 2,
    backgroundColor: "transparent",
    width: referance?.width ? `${referance.width}mm` : "100%",
    minHeight: referance?.height ? `${referance.height}mm` : "auto",
    textAlign: "center",
    marginBottom: 10,
    position:"absolute",
    top: referance?.line3 === "dikey"
      ? `${referance?.topstart + index * referance?.topinc}px`
      : `${referance?.topstart}px`,                       // fixed if "dikey"

    left: referance?.line3 === "yatay"
      ? `${referance?.leftstart + index * referance?.leftinc}px`       // <--- your custom formula here
      : `${referance?.leftstart}px`,                       // fixed if "dikey"
  }}
  
>
                  <Page1
                    key={groupObj.startIndex + index}
                    selectColor={selectColor}
                    barcodeValue={`0${data?.articleNo?.split('/')[0]}${data?.articleNo?.split('/')[1]}${(tab === 10 || tab === "10" ? data?.extraHomeCardLabel?.[selectColor]?.colorCode : data?.priceLabel?.[selectColor]?.colorCode) || ''}${sizeData.sCode ? sizeData.sCode : ''}`}
                    data={data}
                    sizeData={sizeData}
                    inx={groupObj.startIndex + index}
                    CardBackBack={CardBackBack}
                    indo={(tab === 10 || tab === "10" ? data?.extraHomeCardLabel?.[selectColor]?.sizes : data?.brandLabel?.[selectColor]?.sizes) || []}
                    szrgrp={data?.sizeGroup}
                    referance={referance}
                  />
                </div>
              ))}
            </div>
          </A4Page>
        ))
      ) : (
        <A4Page key={1} type="dikey">
          <div className="space-y-5" style={{ position: 'relative' }}>
            <TopDetail values={data} selectColor={selectColor} tab={tab} />
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", paddingTop: 40 }}>
              <CardComponent referenceCode={referance?.code} data={data} selectedFscType={data.company?.fsctype} referance={referance} />
            </div>
          </div>
        </A4Page>
      )}
    </div>
  );
};

export default React.forwardRef(EkstraMain);
